import { useLocaleContext } from '@src/components/locale/locale.context'
import { ECOUNTRIES } from '@src/config/i18n.config'
import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { parseLocale } from '@src/utils/i18n.utils'

export default function useReviewSystemV3Experiment(): {
  showReviewSummary: boolean
  showReviewFilterTags: boolean
  showReviewSummaryAndFilterTags: boolean
} {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_REVIEW_SYSTEM_V3)
  const { locale } = useLocaleContext()
  const country = parseLocale(locale).country
  const showReviewSummary = experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_A && country === ECOUNTRIES.us
  const showReviewFilterTags = experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_B && country === ECOUNTRIES.us
  const showReviewSummaryAndFilterTags =
    experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_C && country === ECOUNTRIES.us
  return { showReviewSummary, showReviewFilterTags, showReviewSummaryAndFilterTags }
}
